// extracted by mini-css-extract-plugin
module.exports = {"CancelContainer":"CancelContainer__1dP0e"};